import { StrictMode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { ConfigProvider } from 'antd';
import './index.scss';
import * as Sentry from '@sentry/react';
import { App } from './App';

// eslint-disable-next-line prefer-const
let pathToConfig = 'PATH_TO_CONFIG_JSON';
const fullPathToConfig = window.location.origin + pathToConfig;

fetch(fullPathToConfig)
  .then((response) => {
    return response.json();
  })
  .then((jsonData) => {
    Sentry.init({
      dsn:
        jsonData?.production === true
          ? 'https://646bbecdd856448fe439f9f37e6f20cf@o4509032899739648.ingest.de.sentry.io/4509032905113680'
          : 'https://61035380cf17dc3cb25f17c898b4d894@o4508726495019008.ingest.de.sentry.io/4508726519660624',
      beforeSend(event) {
        // Check if the event's URL is localhost and prevent sending
        const { hostname } = window.location;
        if (hostname === 'localhost' || hostname === '127.0.0.1') {
          return null;
        }
        return event;
      },
      integrations: [Sentry.replayIntegration()],
      tracesSampleRate: 1.0,

      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });

    const rootElem = document.getElementById('root');
    if (rootElem != null) {
      createRoot(document.getElementById('root')!).render(
        <StrictMode>
          <BrowserRouter>
            <ConfigProvider
              theme={{
                token: {
                  colorPrimary: '#005fcc',
                  borderRadius: 12,
                },
                components: {
                  Popover: {
                    colorBgElevated: '#E9E9EA',
                    colorText: '#3F3D3D',
                    borderRadius: 4,
                  },
                },
              }}
            >
              <App />
            </ConfigProvider>
          </BrowserRouter>
        </StrictMode>,
      );
    }
  })
  .catch((error) => {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.error('Error fetching JSON:', error);
    }
  });
